module.exports = __webpack_public_path__ + "static/media/ly.592a5116.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ly.svg
// module id = 181
// module chunks = 0